import { mapGetters } from 'vuex'
import utils from '@/util'

const TOOLTIP_INITIAL_DELAY_MS = 500
const TOOLTIP_VISIBLE_DURATION_MS = 500

export default {
  data() {
    return {
      tooltipProps: null,
      tooltipCallId: 0,
    }
  },

  computed: {
    ...mapGetters('aiChatbotImportPptxPdf', [
      'isUploadingFile',
      'isAIChatbotImportModalVisibleV2',
    ]),

    shouldShowTooltip() {
      return this.isUploadingFile && !this.isAIChatbotImportModalVisibleV2
    },
  },

  watch: {
    shouldShowTooltip(newValue) {
      this.tooltipCallId += 1 // Invalidate any ongoing showUploadTooltip calls
      if (newValue) {
        this.showUploadTooltip(this.tooltipCallId)
      } else {
        this.hideUploadTooltip()
      }
    },
  },

  methods: {
    hideUploadTooltip() {
      this.tooltipProps = null
    },

    async showUploadTooltip(callId) {
      await utils.sleep(TOOLTIP_INITIAL_DELAY_MS)
      if (callId !== this.tooltipCallId) return

      this.tooltipProps = {
        text: this.$i18nPresenter.t('Uploading your file…'),
        placement: this.tooltipPlacement, // Provided by component
        trigger: 'manual',
        visible: true,
        to: this.tooltipTarget, // Provided by component
        popperOptions: {
          modifiers: {
            preventOverflow: {
              escapeWithReference: true,
            },
          },
        },
      }

      await utils.sleep(TOOLTIP_VISIBLE_DURATION_MS)
      if (callId !== this.tooltipCallId) return

      // Ensure tooltipProps was not cleared while waiting
      if (!this.tooltipProps) return

      this.tooltipProps = {
        ...this.tooltipProps,
        trigger: 'mouseenter focus',
      }
    },
  },
}
